import 'windi.css'
import routes from './routes'

export default {
  name: 'source-view-vulkan',
  title: '模型预览5.0',
  version: '0.1.4',
  description: '模型预览5.0',
  routes, // 导出相关路由
  sysRoutes: [],
  dependencies: {
    apis: ['DirectoryApi', 'MaterialApi', 'FileApi', 'ModelSceneApi'],
  },
  config: {}
}
